/* Gift finder (sections/cs-gift-finder.liquid)
   <cs-gift-finder>: the Shopping for and Spending tabs pick which cards
   show: the chosen person's Picks whose price is in the chosen range, in
   their block order, up to data-picks. The result line says how many.
   ADD is handled by assets/pro-cart.js ([data-pro-add]).
*/

if (!customElements.get('cs-gift-finder')) {
    class CsGiftFinder extends HTMLElement {
        connectedCallback() {
            this.picks = Number(this.dataset.picks) || 3;
            this.recipientOptions = Array.from(this.querySelectorAll('[data-recipient]:not([data-card])'));
            this.budgetOptions = Array.from(this.querySelectorAll('[data-budget]'));
            this.cards = Array.from(this.querySelectorAll('[data-card]'));
            this.cardsRow = this.querySelector('[data-cards]');
            this.result = this.querySelector('[data-result]');

            [...this.recipientOptions, ...this.budgetOptions].forEach((option) => {
                option.addEventListener('click', () => this.select(option));
            });

            // Theme editor: selecting a Shopping for or Spending block selects
            // its tab; selecting a Pick selects its person and a budget it
            // fits, so the card shows
            this.onBlockSelect = (event) => {
                const isBlock = (element) => element.dataset.shopifyEditorBlock?.includes(event.detail.blockId);
                const option = [...this.recipientOptions, ...this.budgetOptions].find(isBlock);
                if (option) {
                    this.select(option);
                    return;
                }
                const card = this.cards.find(isBlock);
                if (!card) return;
                const recipient = this.recipientOptions.find(
                    (entry) => entry.dataset.recipient === card.dataset.recipient
                );
                const price = Number(card.dataset.price);
                const budget = this.budgetOptions.find((entry) => {
                    const max = entry.dataset.max ? Number(entry.dataset.max) : Infinity;
                    return price >= Number(entry.dataset.min || 0) && price <= max;
                });
                if (recipient) this.select(recipient);
                if (budget) this.select(budget);
            };
            document.addEventListener('shopify:block:select', this.onBlockSelect);

            this.update();
        }

        disconnectedCallback() {
            document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        // Makes the tab the only active one in its group
        select(option) {
            const group = this.recipientOptions.includes(option) ? this.recipientOptions : this.budgetOptions;
            group.forEach((entry) => {
                const isActive = entry === option;
                entry.classList.toggle('is-active', isActive);
                entry.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            });
            this.update();
        }

        update() {
            const recipient = this.recipientOptions.find((option) => option.classList.contains('is-active'));
            const budget = this.budgetOptions.find((option) => option.classList.contains('is-active'));
            const min = Number(budget?.dataset.min) || 0;
            const max = budget?.dataset.max ? Number(budget.dataset.max) : Infinity;

            let count = 0;
            let lastShown = null;
            this.cards.forEach((card) => {
                const price = Number(card.dataset.price);
                const matches =
                    card.dataset.recipient === recipient?.dataset.recipient && price >= min && price <= max;
                const show = matches && count < this.picks;
                card.hidden = !show;
                card.classList.remove('is-last');
                if (show) {
                    count += 1;
                    lastShown = card;
                }
            });
            // Fewer picks than columns: the last one closes its right edge
            // (.pro-intro-row in pro-system.css)
            if (lastShown && count < this.picks) lastShown.classList.add('is-last');
            this.cardsRow?.scrollTo({ left: 0, behavior: 'instant' });

            if (!this.result) return;
            const fill = (template) =>
                (template || '')
                    .replaceAll('[count]', count)
                    .replaceAll('[picks]', count === 1 ? this.result.dataset.pick : this.result.dataset.picks)
                    .replaceAll('[recipient]', recipient?.dataset.resultName || '')
                    .replaceAll('[budget]', budget?.dataset.resultLabel || '');
            this.result.innerHTML = fill(count ? this.result.dataset.template : this.result.dataset.empty);
        }
    }

    customElements.define('cs-gift-finder', CsGiftFinder);
}
